/* Nameg — Prestige Dynamic Effects v2 */
(function() {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isDesktop = window.innerWidth > 1024;
  var isTouch = window.matchMedia('(pointer: coarse)').matches;

  /* ---- Scroll-triggered reveals ---- */
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -60px 0px' });

    document.addEventListener('DOMContentLoaded', function() {
      /* Reveal home sections */
      document.querySelectorAll('.home-section, .index-section').forEach(function(el) {
        el.classList.add('reveal-on-scroll');
        revealObserver.observe(el);
      });

      /* Stagger product grids — elegant cascade */
      document.querySelectorAll('.grid-item, .halo-item, .product-item, .product-card').forEach(function(el, i) {
        el.classList.add('reveal-on-scroll');
        el.style.transitionDelay = (i % 6) * 0.08 + 's';
        revealObserver.observe(el);
      });

      /* Reveal images with curtain wipe */
      document.querySelectorAll('.reveal-image').forEach(function(el) {
        revealObserver.observe(el);
      });
    });
  }

  /* ---- Parallax on scroll (desktop, respects reduced-motion) ---- */
  var parallaxElements = [];
  if (!prefersReducedMotion && window.innerWidth > 768) {
    document.addEventListener('DOMContentLoaded', function() {
      /* Exclude .home-slideshow img — parallax overwrites the CSS Ken Burns scale(1.05) transform,
         breaking the 8s ambient zoom. Parallax adds nothing to 100vh overflow:hidden hero. */
      document.querySelectorAll('.sub-banner img, .custom-block-banner img').forEach(function(img) {
        parallaxElements.push(img);
      });
    });
  }

  /* ---- Scroll progress bar ---- */
  var scrollBar = null;
  document.addEventListener('DOMContentLoaded', function() {
    scrollBar = document.createElement('div');
    scrollBar.id = 'nameg-scroll-progress';
    document.body.appendChild(scrollBar);
  });

  /* ---- Unified scroll handler (RAF-throttled) ---- */
  var scrollTicking = false;
  /* Grab .wrapper-header immediately — script runs at bottom of <body> so DOM is parsed.
     Fallback: re-query on first scroll if null (covers edge cases with async rendering). */
  var wrapperHeader = document.querySelector('.wrapper-header');
  window.addEventListener('scroll', function() {
    if (!scrollTicking) {
      requestAnimationFrame(function() {
        var scrollY = window.pageYOffset;
        var docHeight = document.documentElement.scrollHeight - window.innerHeight;

        /* Parallax */
        parallaxElements.forEach(function(img) {
          var rect = img.getBoundingClientRect();
          if (rect.bottom > 0 && rect.top < window.innerHeight) {
            var offset = (rect.top / window.innerHeight) * 20;
            img.style.transform = 'translateY(' + offset + 'px) scale(1.05)';
          }
        });

        /* Scroll progress bar */
        if (scrollBar && docHeight > 0) {
          scrollBar.style.width = (scrollY / docHeight * 100) + '%';
        }

        /* Header scroll effect disabled — static header, same size at all scroll positions.
           CSS also neutralizes .header-scrolled as a safety net. */

        scrollTicking = false;
      });
      scrollTicking = true;
    }
  });

  /* ---- DOMContentLoaded: header, image reveals, back-to-top ---- */
  document.addEventListener('DOMContentLoaded', function() {

    /* Smooth image reveal on load */
    document.querySelectorAll('.product_image img, .product-image img').forEach(function(img) {
      if (img.complete) {
        img.style.opacity = '1';
      } else {
        img.style.opacity = '0';
        img.style.transition = 'opacity 0.5s ease';
        img.addEventListener('load', function() {
          img.style.opacity = '1';
        });
      }
    });

    /* ---- Magnetic hover on buttons (desktop only) ---- */
    if (isDesktop && !isTouch && !prefersReducedMotion) {
      document.querySelectorAll('.btn, .slide-button, .product__add-to-cart, .btn-addToCart, .nameg-hero-btn').forEach(function(btn) {
        btn.setAttribute('data-magnetic', '');

        btn.addEventListener('mousemove', function(e) {
          var rect = btn.getBoundingClientRect();
          var x = e.clientX - rect.left - rect.width / 2;
          var y = e.clientY - rect.top - rect.height / 2;
          btn.style.transform = 'translate(' + (x * 0.2) + 'px, ' + (y * 0.2) + 'px)';
        });

        btn.addEventListener('mouseleave', function() {
          btn.style.transform = '';
        });
      });
    }

    /* ---- Product card subtle 3D tilt (desktop only) ---- */
    if (isDesktop && !isTouch && !prefersReducedMotion) {
      document.querySelectorAll('.product-item, .grid-item, .halo-item').forEach(function(card) {
        card.addEventListener('mousemove', function(e) {
          var rect = card.getBoundingClientRect();
          var x = (e.clientX - rect.left) / rect.width;
          var y = (e.clientY - rect.top) / rect.height;
          var tiltX = (0.5 - y) * 6;
          var tiltY = (x - 0.5) * 6;
          card.style.transform = 'translateY(-8px) perspective(800px) rotateX(' + tiltX + 'deg) rotateY(' + tiltY + 'deg)';
        });

        card.addEventListener('mouseleave', function() {
          card.style.transform = '';
        });
      });
    }
  });

})();

/* ---- Synchronized rotating category images ---- */
(function() {
  function initSyncRotators() {
    var containers = document.querySelectorAll('.rotating-images');
    if (containers.length === 0) return;

    var active = [];
    containers.forEach(function(container) {
      if (container.dataset.rotateActive) return;
      var slides = container.querySelectorAll('.rotate-slide');
      if (slides.length < 2) return;
      container.dataset.rotateActive = '1';
      active.push({ el: container, slides: slides });
    });
    if (active.length === 0) return;

    var speed = parseInt(active[0].el.dataset.rotateSpeed) || 4000;

    setInterval(function() {
      active.forEach(function(item) {
        var current = item.el.querySelector('.rotate-slide.active');
        if (!current) {
          var first = item.slides[0];
          /* Restart Ken Burns on the incoming slide */
          first.style.animation = 'none';
          /* Force reflow so the browser discards the old animation state */
          void first.offsetWidth;
          first.style.animation = '';
          first.classList.add('active');
          return;
        }
        current.classList.remove('active');
        var next = current.nextElementSibling;
        if (!next || !next.classList.contains('rotate-slide')) {
          next = item.slides[0];
        }
        /* Restart Ken Burns: strip animation, force reflow, re-apply */
        next.style.animation = 'none';
        void next.offsetWidth;
        next.style.animation = '';
        next.classList.add('active');
      });
    }, speed);
  }

  /* Script loads dynamically after DOMContentLoaded has already fired,
     so we check readyState and call immediately if DOM is ready. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initSyncRotators, 1500);
    });
  } else {
    setTimeout(initSyncRotators, 500);
  }
})();

/* ---- Force autoplay & lazy loading fixes ---- */
document.addEventListener('DOMContentLoaded', function() {

  /* 1. Force-load above-the-fold images */
  function forceLoadAboveFold() {
    var viewH = window.innerHeight;
    document.querySelectorAll('img.lazyload, img.lazyautosizes, img[data-src], img[data-srcset]').forEach(function(img) {
      var rect = img.getBoundingClientRect();
      if (rect.top < viewH + 200) {
        if (img.dataset.src) img.src = img.dataset.src;
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.classList.remove('lazyload', 'lazyloading');
        img.classList.add('lazyloaded');
        img.style.opacity = '1';
      }
    });
  }
  forceLoadAboveFold();
  setTimeout(forceLoadAboveFold, 500);
  setTimeout(forceLoadAboveFold, 1500);

  /* 2. Force Slick carousel autoplay + crossfade on hero
     (Removed manual setInterval autoplay — it conflicted with Slick's native
      autoplay, causing double-advance at irregular intervals.) */
  setTimeout(function() {
    if (typeof jQuery !== 'undefined' && jQuery.fn.slick) {
      var $hero = jQuery('.home-slideshow .slick-initialized');
      if ($hero.length) {
        try {
          $hero.slick('slickSetOption', 'fade', true, false);
          $hero.slick('slickSetOption', 'speed', 1200, false);
          $hero.slick('slickSetOption', 'cssEase', 'ease', false);
        } catch(e) {}
      }

      jQuery('.slick-initialized').each(function() {
        try {
          var $s = jQuery(this);
          $s.slick('slickSetOption', 'autoplay', true, false);
          $s.slick('slickSetOption', 'autoplaySpeed', 4000, false);
          $s.slick('slickSetOption', 'pauseOnHover', true, false);
          $s.slick('slickPlay');
        } catch(e) {}
      });
    }
  }, 3000);

  /* 4. Undo broken Slick on Bootstrap rows */
  setTimeout(function() {
    if (typeof jQuery !== 'undefined' && jQuery.fn.slick) {
      jQuery('.home-featured-products-sections .row.slick-initialized, .home-new-arrivals-sections .row.slick-initialized').each(function() {
        try { jQuery(this).slick('unslick'); } catch(e) {}
      });
    }
    document.querySelectorAll('.home-featured-products-sections .container > .row, .home-new-arrivals-sections .container > .row').forEach(function(row) {
      row.removeAttribute('style');
      row.querySelectorAll('[class*="col-"]').forEach(function(col) {
        col.removeAttribute('style');
      });
    });
  }, 2000);

  /* 5. Back-to-top button */
  /* Floating action buttons: back-to-top + sign-in + cart */
  var fab = document.createElement('div');
  fab.className = 'nameg-fab-group';
  fab.innerHTML =
    '<a href="/account/login" class="nameg-fab nameg-fab-signin" aria-label="Sign In">' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>' +
    '</a>' +
    '<a href="/cart" class="nameg-fab nameg-fab-cart" aria-label="Cart">' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
    '</a>' +
    '<button class="nameg-fab nameg-fab-top" aria-label="Back to top">&#8593;</button>';
  document.body.appendChild(fab);
  window.addEventListener('scroll', function() {
    fab.classList.toggle('visible', window.pageYOffset > 400);
  });
  fab.querySelector('.nameg-fab-top').addEventListener('click', function() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  /* 6. Section heading reveal on scroll */
  if ('IntersectionObserver' in window) {
    var headings = document.querySelectorAll('.home-section .heading h2, .index-section .heading h2');
    var headingObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          headingObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    headings.forEach(function(h) {
      h.style.opacity = '0';
      h.style.transform = 'translateY(20px)';
      h.style.transition = 'opacity 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94), transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      headingObserver.observe(h);
    });
  }

  /* 7. Staggered section entrance — each section animates its children */
  if ('IntersectionObserver' in window) {
    var sectionObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var children = entry.target.querySelectorAll('.grid-item, .halo-item, .product-item, .blog-item, .carousel-slide');
          children.forEach(function(child, i) {
            setTimeout(function() {
              child.style.opacity = '1';
              child.style.transform = 'translateY(0)';
            }, i * 80);
          });
          sectionObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.featured-products .row, .new-arrivals-product .row, .home-custom-block-baner .row').forEach(function(section) {
      var items = section.querySelectorAll('.grid-item, .halo-item, .product-item');
      items.forEach(function(item) {
        item.style.opacity = '0';
        item.style.transform = 'translateY(24px)';
        item.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      });
      sectionObserver.observe(section);
    });
  }

  /* Fallback: if IntersectionObserver is missing or elements stay hidden, force-reveal after 4s */
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.home-section .heading h2, .index-section .heading h2').forEach(function(h) {
      h.style.opacity = '1';
      h.style.transform = 'translateY(0)';
    });
    document.querySelectorAll('.grid-item, .halo-item, .product-item, .blog-item, .carousel-slide').forEach(function(el) {
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    });
  } else {
    /* Safety net: reveal any still-hidden elements after 4s in case observer fails */
    setTimeout(function() {
      document.querySelectorAll('.home-section .heading h2, .index-section .heading h2, .grid-item, .halo-item, .product-item, .blog-item, .carousel-slide').forEach(function(el) {
        if (el.style.opacity === '0') {
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
        }
      });
    }, 4000);
  }
});
